export const iconFontAwesomeMediaplaybackRepeat = (
	<i className="fa-solid fa-repeat"></i>
);
